module.exports = __webpack_public_path__ + "img/cart-black.d399191f.svg";